"use client";

import createIcon from './util/createIcon';
export default createIcon('M6,18L14.5,12L6,6M8,9.86L11.03,12L8,14.14M16,6H18V18H16', 'SkipNextOutline');